import { translationKey } from '@change-corgi/core/i18n';

export const MAX_VIDEO_COUNT = 5;
export const MAX_IMAGE_COUNT = 20;

export const NON_SAFE_URL_ERROR_KEY = translationKey('corgi.components.rich_media.error.invalid_youtube_url');
export const NO_TEXT_ERROR_KEY = translationKey('corgi.components.rich_media.error.no_text');
export const MAX_VIDEO_ERROR_TEXT = translationKey('corgi.components.rich_media.error.exceeded_max_videos');
export const MAX_IMAGE_ERROR_TEXT = translationKey('corgi.components.rich_media.error.exceeded_max_images');
